import { useMutation } from '@tanstack/react-query';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

type AddAIPromptTemplateDto = {
  aiId: number;
  template: string;
};

export const addAIPromptTemplate = (data: AddAIPromptTemplateDto) => {
  return axios.put('/ai/prompt-templates', data);
};

type QueryFnType = typeof addAIPromptTemplate;

type UseAddAIPromptTemplateOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useAddAIPromptTemplate = ({ config }: UseAddAIPromptTemplateOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['ai-prompt-templates']);
      onSuccess?.(...args);
    },
    mutationFn: addAIPromptTemplate,
  });
};
